import Vue from 'vue';
import Router from 'vue-router';
import DashboardPage from '@/pages/DashboardPage';
import DonationsPage from '@/pages/DonationsPage';
import ProgramsPage from '@/pages/ProgramsPage';
import LocationsPage from '@/pages/LocationsPage';
import ImpactPage from '@/pages/ImpactPage';
import AboutPage from '@/pages/AboutPage';
import CareersPage from '@/pages/CareersPage';
import SignInPage from '@/pages/SignInPage';

import AuthGuard from './auth-guard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/signin',
      name: 'signin',
      component: SignInPage
    },
    {
      path: '/',
      name: 'dashboard',
      component: DashboardPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/donations',
      name: 'DonationsPage',
      component: DonationsPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/programs',
      name: 'ProgramsPage',
      component: ProgramsPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/locations',
      name: 'LocationsPage',
      component: LocationsPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/impact',
      name: 'ImpactPage',
      component: ImpactPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/careers',
      name: 'CareersPage',
      component: CareersPage,
      beforeEnter: AuthGuard
    },
    {
      path: '*',
      name: '404',
      redirect: '/'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js